export const actionTypes = {
    getData: "[publishers] Get publishers data",
    getDataForFeePage: "[publishers] Get publishers data for fee page",
    getDataForPayoutsManagementPage: "[payouts-management] Get publishers data for payouts management page",
    createPublisher: "[publishers] Create publisher",
    editPublisher: "[publishers] Edit publisher",
    deletePublisher: "[publishers] Delete publisher",
    editCompanyData: "[publishers] Edit company data",
    checkVatNumber: "[publishers] Check VAT number",
    getCurrencyFromLS: "[currency-by-publisher] get currency by publisher from localStorage",
    setCurrencyToLS: "[currency-by-publisher] set currency by publisher to localStorage",
    setSelectedPublishersLtba: "[publishers] Set selected LTBA publishers array",
    setSelectedPublisherLtba: "[publishers] Set selected LTBA publisher (single)",
    setSelectedPublishersYield: "[publishers] Set selected Yield publishers array",
    setSelectedMode: "[publishers] Set selected mode (ltba/yield)",

    // Separated LTBA actions
    setSelectedWebsitesLtba: "[publishers] Set selected LTBA websites",

    // Separated Yield actions
    setSelectedWebsitesYield: "[publishers] Set selected Yield websites",

    restoreFromLS: "[publishers] Restore from localStorage",
    clearPersistantStorage: "[publishers] Clear persistant storage",
};

export const mutationTypes = {
    publishersGetDataStart: "[publishers] Publishers get data start",
    publishersGetDataSuccess: "[publishers] Publishers get data success",
    publishersGetDataFailure: "[publishers] Publishers get data failure",

    publishersGetDataForFeePageStart: "[publishers-fee] Publishers get data for fee page start",
    publishersGetDataForFeePageSuccess: "[publishers-fee] Publishers get data for fee page success",
    publishersGetDataForFeePageFailure: "[publishers-fee] Publishers get data for fee page failure",

    publishersGetDataForPayoutsManagementPageStart:
        "[publishers-payouts-management] Publishers get data for payouts management page start",
    publishersGetDataForPayoutsManagementPageSuccess:
        "[publishers-payouts-management] Publishers get data for payouts management page success",
    publishersGetDataForPayoutsManagementPageFailure:
        "[publishers-payouts-management] Publishers get data for payouts management page failure",

    createPublisherStart: "[publishers] Create publisher start",
    createPublisherSuccess: "[publishers] Create publisher success",
    createPublisherFailure: "[publishers] Create publisher failure",
    createPublisherErrors: "[publishers] Create publisher errors",

    deletePublisherStart: "[publishers] Delete publisher start",
    deletePublisherSuccess: "[publishers] Delete publisher success",
    deletePublisherFailure: "[publishers] Delete publisher failure",
    deletePublisherErrors: "[publishers] Delete publisher errors",

    companyEditDataStart: "[publishers] Company edit data start",
    companyEditDataSuccess: "[publishers] Company edit data success",
    companyEditDataFailure: "[publishers] Company edit data failure",
    companyEditDataErrors: "[publishers] Company edit data errors",
    checkVAtNumberStart: "[publishers] Check VAT number start",
    checkVAtNumberSuccess: "[publishers] Check VAT number success",
    checkVAtNumberFailure: "[publishers] Check VAT number failure",
    setCurrencyBySelectedPublisher: "[publishers] Set currency by selected publisher",
    setSelectedPublishersLtba: "[publishers] Set selected LTBA publishers array",
    setSelectedPublishersYield: "[publishers] Set selected Yield publishers array",
    setSelectedMode: "[publishers] Set selected mode",

    // Separated LTBA mutations
    setSelectedWebsitesLtba: "[publishers] Set selected LTBA websites",

    // Separated Yield mutations
    setSelectedWebsitesYield: "[publishers] Set selected Yield websites",
};

// localStorage keys for persisted dashboard selections. Centralized so adding a
// new dashboard-specific selection or renaming a key is a one-line change.
export const LS_KEYS = {
    PUBLISHERS_LTBA: "publishers_selectedPublishersLtba",
    PUBLISHERS_YIELD: "publishers_selectedPublishersYield",
    WEBSITES_LTBA: "publishers_selectedWebsitesLtba",
    WEBSITES_YIELD: "publishers_selectedWebsitesYield",
    MODE: "publishers_selectedMode",
    DATES_LTBA: "ltba_website_dates",
    DATES_YIELD: "yield_website_dates",
};

export const getterTypes = {
    getIsLoading: "[publishers] Get loader",
    getPublishers: "[publishers] Get publishers",
    getPublishersForFeePage: "[publishers-fee] Get publishers for fee page",
    getPublishersForPayoutsManagementPage: "[publishers-payouts-management] Get publishers for payouts management page",
    getPublisher: "[publisher] Get main publisher",
    getVatNumber: "[publisher] Get VAT number",
    getCompanyAccountErrors: "[publisher] Get errors for company account form",
    getSelectedPublisher: "[publisher] Get selectedPublisher",
    getSelectedPublisherCurrency: "[publisher] Get selectedPublisherCurrency",
    getCreatePublisherErrors: "[publisher-create] Get errors",
    getDeletePublisherErrors: "[publisher-delete] Get errors",
    getSelectedPublishersLtba: "[publishers] Get selected LTBA publishers array",
    getSelectedPublisherLtba: "[publishers] Get selected LTBA publisher (first from array)",
    getSelectedPublishersYield: "[publishers] Get selected Yield publishers array",
    getSelectedMode: "[publishers] Get selected mode",

    // Separated LTBA getters
    getSelectedWebsitesLtba: "[publishers] Get selected LTBA websites",

    // Separated Yield getters
    getSelectedWebsitesYield: "[publishers] Get selected Yield websites",
};
